import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { IRootState } from "../../../../reducer/CombineReducer";
import { CreateConfigView } from "./CreateConfig.view";

interface CreateConfigProps {
  /**
   * Flag to show the dialog
   */
  showDialog: boolean;
  /**
   * Close handler for the dialog
   */
  onClose: () => void;
  /**
   * Close handler for the dialog
   */
  onSave: () => void;
}

/**
 * Responsible for rendering the Create Config UI
 * @returns Create Config component
 */
export const CreateConfig: React.FC<CreateConfigProps> = (props: CreateConfigProps): JSX.Element => {
  const { showDialog, onClose, onSave } = props;
  const [
    outputConfig,
    notificationState
  ] = useSelector((state: IRootState) => [
    state.outputConfig,
    state.notificationState
  ], shallowEqual);
  const configName = outputConfig?.editConfig?.configName;
  const fileName = outputConfig?.editConfig?.fileName;

  return (
    <CreateConfigView
      showDialog={showDialog}
      onClose={onClose}
      onSave={onSave}
      configName={configName}
      fileName={fileName}
      notificationItems={notificationState.notificationItems}
    />
  );
};
